import _ from '@lodash';

const ClientModel = (data) => {
  const model = _.defaults(data ? {...data, teams: undefined, users: undefined, unread: undefined }: {}, {
    firstName: '',
    middleName: '',
    lastName: '',
    dateOfBirth: '',
    governmentIdNumber: '',
    preferredLanguage: '',
    race: '',
    ethnicity: '',
    maritalStatus: '',
    deceased: false,
    dateOfDeath: '',
    about: '',
    email: '',
    phone: '',
    stateProvince: '',
    city: '',
    postalCode: '',
    gender: '',
    clientType: '',
    clientCategory: 'Primary',
    status: 'Active',
    relatedClients: [],
    treatmentAreas: [],
    folderId: '',
    attachmentsFolderId: '',
    tasksFolderId: '',
    downloadableFilesFolderId: '',
    settings: {}
  });
  
  // Clean up settings - remove null/undefined values
  if (model.settings) {
    model.settings = Object.fromEntries(
      Object.entries(model.settings).filter(([_, v]) => v !== null && v !== undefined)
    );
    if (Object.keys(model.settings).length === 0) {
      delete model.settings;
    }
  }
  
  return model;
};

export default ClientModel;
